module.exports = __webpack_public_path__ + "static/media/get-direction.4cb7f4a7.svg";